import { render, staticRenderFns } from "./AvatarWrapper.vue?vue&type=template&id=a987b93e&scoped=true"
import script from "./AvatarWrapper.vue?vue&type=script&lang=ts"
export * from "./AvatarWrapper.vue?vue&type=script&lang=ts"
import style0 from "./AvatarWrapper.vue?vue&type=style&index=0&id=a987b93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a987b93e",
  null
  
)

export default component.exports